export const PopularRank = ({ rank }) => {
  const isTopRank = Number(rank) <= 3;

  return (
    <span className="flex w-8 shrink-0 items-center justify-center">
      <span
        className={
          isTopRank
            ? "flex h-6 w-6 items-center justify-center rounded-lg border border-[#ECECEE] bg-[#F5F5F6] text-[14px] font-semibold leading-none text-[#8C9098] dark:border-white/10 dark:bg-white/10 dark:text-white/60"
            : "flex h-6 w-6 items-center justify-center text-[15px] font-semibold leading-none text-[#9AA0A8] dark:text-white/45"
        }
      >
        {rank}
      </span>
    </span>
  );
};

const popularItemStyles = {
  mobile: {
    row: "flex min-h-[41px] w-full items-center gap-3 text-left",
    label: "min-w-0 flex-1 truncate text-[15px] font-semibold leading-5",
  },
  desktop: {
    row: "flex min-h-[44px] w-full items-center gap-3 text-left",
    label: "min-w-0 flex-1 truncate text-[14px] font-semibold leading-5",
  },
};

// showRanking = 실제 검색량이 집계된 상태. 씨앗 검색어(frequency 0)일 때는
// 순위와 NEW 배지를 감춘다 — 없는 근거를 주장하지 않기 위해서다.
export const PopularSearchItem = ({
  item,
  index,
  total,
  isActive = false,
  onMouseEnter,
  onSubmit,
  variant = "mobile",
  showRanking = true,
}) => {
  const styles = popularItemStyles[variant] || popularItemStyles.mobile;
  const hasDivider = index < total - 1;

  return (
    <button
      type="button"
      className={`${styles.row} ${
        isActive
          ? "bg-black/[0.06] dark:bg-white/[0.09]"
          : "hover:bg-black/[0.035] dark:hover:bg-white/[0.06]"
      } ${
        hasDivider ? "border-b border-black/10 dark:border-white/10" : ""
      }`}
      aria-selected={isActive}
      onMouseEnter={onMouseEnter}
      onClick={() => onSubmit(item.searchTerm)}
    >
      {showRanking && <PopularRank rank={item.rank} />}
      <span className={styles.label}>{item.searchTerm}</span>
      {showRanking && <PopularTrendBadge item={item} />}
    </button>
  );
};

export const PopularTrendBadge = ({ item }) => {
  const direction = String(item?.trendDirection || "same").toLowerCase();
  const rawChange = Number(item?.rankChange);
  const change = Number.isFinite(rawChange) && rawChange !== 0 ? Math.abs(rawChange) : null;

  if (item?.isNew || direction === "new") {
    return (
      <span className="shrink-0 text-[12px] font-semibold uppercase tracking-[0.02em] text-ink dark:text-ink_on_dark">
        new
      </span>
    );
  }

  if (direction === "up" || rawChange > 0) {
    return (
      <span className="shrink-0 text-[12px] font-semibold text-ink dark:text-ink_on_dark">
        ▲ {change || 1}
      </span>
    );
  }

  if (direction === "down" || rawChange < 0) {
    return (
      <span className="shrink-0 text-[12px] font-semibold text-ink-45 dark:text-ink_on_dark-45">
        ▼ {change || 1}
      </span>
    );
  }

  return (
    <span className="shrink-0 text-[13px] font-medium text-black/30 dark:text-white/30">
      -
    </span>
  );
};
